import React from "react";
import styled from "styled-components";
import freshworks from "../../assets/freshworks.jpg";

function Experience() {
  return (
    <MainExperience id="experience">
      <ExperienceWrapper>
        <Tag>Experience</Tag>
        <ExperienceSection>
          {/* Left Box with Company Image */}
          <LeftBoxContainer>
            <LeftBox>
              <img
                src={freshworks} // Replace with the company's logo or a related image
                alt="Company"
              />
              <p>
                <strong>Software Engineer - Frontend</strong>
                <div style={{ marginTop: "2px" }}>March 2022 - Present</div>
                <br />
              </p>
            </LeftBox>
          </LeftBoxContainer>

          {/* Right Box with Experience Details */}
          <RightBox>
            <p data-aos="fade-left">
              In my role at Freshworks, I have worked on multiple features and
              projects, primarily focusing on web development. The technologies
              I work with include React, JavaScript, TypeScript, and CSS.
              Additionally, I utilize tools such as Sentry for error tracking,
              Heap for analytics, GitHub for version control, AWS for cloud
              infrastructure, Jenkins for CI/CD, SonarQube for code quality,
              Jest for unit testing, and ensure high test coverage through
              comprehensive unit and integration tests.
              <ul>
                <li>
                  <span style={{ fontWeight: "bold" }}>
                    Web Development Expertise:
                  </span>{" "}
                  Developed and maintained scalable web applications using
                  React, JavaScript, TypeScript, and CSS frameworks.
                </li>
                <li>
                  <span style={{ fontWeight: "bold" }}>
                    Component Architecture:
                  </span>{" "}
                  Designed modular, reusable components to ensure maintainable
                  and efficient codebases.
                </li>
                <li>
                  <span style={{ fontWeight: "bold" }}>
                    Feature Implementation:
                  </span>{" "}
                  Implemented complex features like role-based access control
                  (RBAC), advanced pagination, subscription management to
                  enhance user experience and meet business requirements.
                </li>
                <li>
                  <span style={{ fontWeight: "bold" }}>API Optimization:</span>{" "}
                  Improved application performance by optimizing API calls,
                  reducing latency, and handling large-scale data efficiently.
                </li>
                <li>
                  <span style={{ fontWeight: "bold" }}>
                    Debugging and Monitoring:
                  </span>{" "}
                  Resolved critical production issues using tools like Sentry
                  for error tracking and Heap for user analytics.
                </li>
                <li>
                  <span style={{ fontWeight: "bold" }}>
                    Testing and Quality Assurance:
                  </span>{" "}
                  Ensured high test coverage by writing comprehensive unit and
                  integration tests using Jest.
                </li>
                <li>
                  <span style={{ fontWeight: "bold" }}>
                    CI/CD and Code Quality:
                  </span>{" "}
                  Leveraged Jenkins for CI/CD pipelines and SonarQube to
                  maintain code quality and reduce technical debt.
                </li>
                <li>
                  <span style={{ fontWeight: "bold" }}>
                    Collaboration and Documentation:
                  </span>{" "}
                  Worked closely with cross-functional teams to brainstorm
                  solutions, and ensure seamless communication across
                  stakeholders.
                </li>
                <li>
                  <span style={{ fontWeight: "bold" }}>
                    Infrastructure Management:
                  </span>{" "}
                  Used AWS for cloud infrastructure, including secure deployment
                  and application monitoring.
                </li>
              </ul>
            </p>
          </RightBox>
        </ExperienceSection>
      </ExperienceWrapper>
    </MainExperience>
  );
}

export default Experience;

const MainExperience = styled.div`
  padding: 100px 0;
`;

const ExperienceWrapper = styled.div`
  margin: 0 auto;
  max-width: 1240px;
`;

const ExperienceSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media screen and (max-width: 890px) {
    flex-direction: column !important;
  }
`;

const Tag = styled.h1`
  font-family: "Space Grotesk";
  font-weight: bold;
  margin-bottom: 2rem;
  font-size: 2rem;
`;

const LeftBoxContainer = styled.div`
  flex: 0.5;
`;

const LeftBox = styled.div`
  img {
    width: 70%;
    border-radius: 20%;
    margin-bottom: 1rem;
  }

  p {
    font-family: "Space Grotesk", sans-serif;

    strong {
      display: block;
      margin-top: 0.5rem;
    }
  }
`;

const RightBox = styled.div`
  flex: 1;

  p {
    line-height: 2rem;
    font-family: "Space Grotesk", sans-serif;
    text-align: justify;
  }

  ul {
    margin-top: 1rem;
    list-style-type: disc;
    padding-left: 2rem;
  }

  li {
    margin-bottom: 0.5rem;
  }
`;
